import type { BaseSelectionItem } from "@trydig/centra-types/selection";
import { getBaseUrl } from "../utils";

export const selectionItemToKlaviyoItem = (item: BaseSelectionItem) => {
	const baseUrl = getBaseUrl();

	return {
		ProductName: item.product?.name,
		ProductID: item.product?.productSku,
		SKU: item.product?.productSku,
		Categories: item.product?.categoryName,
		ImageURL: item.product?.media?.standard?.[0],
		URL: `${baseUrl}/${item.product?.uri}`,
		Brand: "Kaos",
		Price: item.priceEach,
		ItemPrice: item.priceEach,
		Quantity: 1,
	};
};
